import React, { useState } from 'react'
import { Select } from 'antd'
import { EditOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons'

function EditableSelectCell(props) {
  const { value, onChange, label } = props
  const [options, setOptions] = useState<any>(null)
  const [editingCell, setEditingCell] = useState(false)

  const onChangeEditing = (editing: boolean) => {
    setOptions(editing ? value : null)
    setEditingCell(editing)
  }

  const onChangeInternal = () => {
    // console.log(value)
    onChange && onChange(options)
    setEditingCell(false)
  }

  return (
    <div>
      {label ? label : null}
      {!editingCell ? value?.map(v => (
        <div key={v}
          style={{
            background: '#fafafa',
            border: '1px solid #d9d9d9',
            borderRadius: '2px',
            padding: '0 4px',
            margin: '0px 4px 2px 0',
            fontSize: '12px',
            listStyle: 'none',
            height: 'auto',
            wordBreak: 'break-all',
            display: 'inline-block',
          }}
        >
          {v}
        </div>
      )) : (
        <Select style={{ display: 'block' }} allowClear mode="tags" value={options} onChange={setOptions} />
      )}
      { !editingCell ? <EditOutlined style={{ color: '#1890ff' }} onClick={() => onChangeEditing(true)} /> : (
        <>
          <CloseOutlined style={{ color: '#dc3545', marginRight: 4 }} onClick={() => onChangeEditing(false)} />
          <CheckOutlined style={{ color: '#28a745' }} onClick={onChangeInternal} />
        </>
      )}
    </div>
  )
}

export default EditableSelectCell
